module.exports = __webpack_public_path__ + "static/media/bg-nav.005598fe.png";